import React from 'react'
import cx from 'classnames'
import { useRadio } from '@react-aria/radio'
import { Check2 } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Price } from 'api/clients/PaymentPlanClient'
import styles from './PlanSelect.module.scss'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

interface BillingOptionProps {
  value: 'monthly' | 'annual'
  label: string
  price: Price
  discount?: boolean
  state: any
}

export function BillingOption({ value, label, price, discount = false, state }: BillingOptionProps) {
  const ref = React.useRef<HTMLInputElement>(null)
  const { inputProps } = useRadio(
    {
      value,
      'aria-label': label,
    },
    state,
    ref,
  )

  const isSelected = state.selectedValue === value
  let priceAmount = value === 'annual' ? price.unit_amount / 12 : price.unit_amount

  if (discount && value === 'annual') {
    priceAmount = (price.unit_amount / 12) * 0.92
  }

  return (
    <div className={styles.optionWrapper}>
      {discount && (
        <div className={styles.specialBadge}>
          <span className={styles.crossedOut}>25%</span> <span className={styles.boldOff}>33% OFF</span> SPECIAL
        </div>
      )}
      <label className={cx(styles.planOption, { [styles.selected]: isSelected })}>
        <div className={styles.radioContainer}>
          <input {...inputProps} ref={ref} className={styles.radioInput} />
          {isSelected && (
            <div className={styles.radioSelected}>
              <Check2 color="var(--light-100)" />
            </div>
          )}
        </div>
        <div className={styles.planContent}>
          <div className={styles.planInfo}>
            <ResponsiveDesign.Mobile>
              <Heading level={5}>{label}</Heading>
            </ResponsiveDesign.Mobile>
            <ResponsiveDesign.Desktop>
              <Heading level={3}>{label}</Heading>
            </ResponsiveDesign.Desktop>
          </div>
          <div className={styles.pricing}>
            <ResponsiveDesign.Desktop>
              <Heading level={2}>${Math.round(priceAmount)}</Heading>
            </ResponsiveDesign.Desktop>
            <ResponsiveDesign.Mobile>
              <Heading level={5}>${Math.round(priceAmount)}</Heading>
            </ResponsiveDesign.Mobile>
            <div className={styles.priceDetails}>
              <Text variant="metadata">per month</Text>
              {value === 'annual' && <Text variant="metadata">(billed annually)</Text>}
            </div>
          </div>
        </div>
      </label>
    </div>
  )
}
